exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sub-el-icon[data-v-31ea41b3] {\r\n  color: currentColor;\r\n  width: 1.2em;\r\n  height: 1.2em;\n}\r\n", ""]);

// exports
